/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IDiagLab } from 'app/shared/model/diag-lab.model';
import { IDiaglabBill } from 'app/shared/model/diaglab-bill.model';
import { IDiaglabAssistant } from 'app/shared/model/diaglab-assistant.model';
import { SamplePriority } from 'app/shared/model/enumerations/sample-priority.model';
import { SourceOfSample } from 'app/shared/model/enumerations/source-of-sample.model';
import { SampleStatus } from 'app/shared/model/enumerations/sample-status.model';
import { TypeOfSample } from 'app/shared/model/enumerations/type-of-sample.model';
import { UOM } from 'app/shared/model/enumerations/uom.model';

export interface IDiaglabSample {
  id?: string;
  accessionNumber?: string;
  domain?: string | null;
  clientReferenceRemarks?: string | null;
  priority?: keyof typeof SamplePriority | null;
  quantity?: number;
  collectionDate?: number | null;
  revision?: number | null;
  referredToOrFrom?: string | null;
  sourceOfSample?: keyof typeof SourceOfSample | null;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  status?: keyof typeof SampleStatus | null;
  typeOfSample?: keyof typeof TypeOfSample | null;
  uom?: keyof typeof UOM | null;
  rejectReason?: string | null;
  diagLab?: IDiagLab | null;
  labBill?: IDiaglabBill | null;
  collector?: IDiaglabAssistant | null;
}

export const defaultValue: Readonly<IDiaglabSample> = {
  active: false,
};
